import React, { useEffect, useState, useMemo, useRef } from 'react';
import Header from '../../components/header';
import Layout from '../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import toast from 'react-hot-toast';
import moment from 'moment';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import Search from '../../components/search';
import Loader from '../../components/loader';
import { useDepreciationApi } from '../../store/api/hooks/depreciationApiHook';
import Button from '../../components/elements/button';
import { useSagesApi } from '../../store/api/hooks/sageApiHook';
import { URLS } from '../../_config';
import Currency from '../../components/currency';
import Drawer from '../../components/Drawer';
import { Dropdown, Menu } from '../../components/Dropdown';
import Filters from '../../components/filters';
import { filterConfigType } from '../../_config/types';
import Icon from '../../components/icons';
import CreateVendor from './_components/createVendor';
import { useVendorsApi } from '../../store/api/hooks/vendorsApiHook';
import { titleCell } from '../../components/elements/function';
import { useDialog } from '../../store/api/hooks/dialogHook';
import { downloadExcel, downloadPDF, getPermissionInfo } from '../../_common/functions';
import { useLocation } from 'react-router-dom';
import { useUserSelector } from '../../store/selectors/userSelector';

ModuleRegistry.registerModules([AllCommunityModule]);

const Vendor: React.FC = () => {
    const location = useLocation();
    const loggedinuser: any = useUserSelector();
    const vendorApi = useVendorsApi();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [rowData, setrowData] = useState<any>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [loadingRowId, setLoadingRowId] = React.useState<string | null>(null);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [filters, setFilters] = useState<any>({});
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);
    const [editData, setEditData] = useState<any>(null);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('vendorFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('vendorFilters', JSON.stringify(filters));
        }
    }, [filters]);

    const filtersRef: any = useRef();
    const createVendorRef: any = useRef();
    const { confirm } = useDialog();

    const getServiceType = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            vendorApi.GetServiceType(
                payload,
                (resp: any) => {
                    resolve(
                        resp?.serviceTypeList
                            ? resp.serviceTypeList.map((st: any) => {
                                return {
                                    label: st.name,
                                    value: st.vendorServiceTypeID,
                                };
                            })
                            : []
                    );
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
    };


    const filterConfig: filterConfigType[] = [
        { name: 'Service Type', type: 'dropdown', key: 'serviceTypeIDs', async: getServiceType as any },
        { name: 'Vendor Name', type: 'text', key: 'vendorName' },
        { name: 'Contact Person Name', type: 'text', key: 'contactPersonName' },
    ]


    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, pinned: "left", minWidth: 50, width: 50, headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Vendor Name',
            field: 'vendorName',
            headerClass: 'bg-[#f0f0f0]',
            pinned: "left", minWidth: 300, width: 100,
            cellRenderer: titleCell
        },
        {
            headerName: 'Contact Person Name',
            field: 'contactPersionName',
            headerClass: 'bg-[#f0f0f0]',
            pinned: "left", minWidth: 160, flex: 1,
            cellRenderer: titleCell

        },
        {
            headerName: 'Contact Person Email',
            field: 'contactPersonEmail',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 170,
            flex: 1,
            cellRenderer: titleCell
        },
        {
            headerName: 'Contact Person Phone',
            field: 'contactPersonPhone',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 170,
            flex: 1,
            cellRenderer: titleCell
        },
        {
            headerName: 'Address',
            field: 'addressStreet',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 170,
            flex: 1,
            cellRenderer: titleCell

        },
        {
            headerName: 'Service Type',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 170,
            flex: 1,
            valueGetter: (params: any) => {
                return params.data?.serviceTypes
                    ?.map((st: any) => st.vendorServiceTypeName)
                    ?.join(', ') || '-';
            },
            cellRenderer: titleCell
        },
        {
            headerName: 'Status',
            field: 'isActive',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 170,
            flex: 1,
            valueGetter: (params: any) => params.data?.isActive === 1 ? 'Active' : 'Inactive',
            cellRenderer: titleCell
        },
        {
            headerName: 'Action',
            field: 'action',
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: 'right',
            width: 90,
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                const action = e.target.value;
                                if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
                                    toast.error(`You don't have ${action} permission`);
                                    e.target.selectedIndex = -1;
                                    return;
                                }
                                handleActionChange(e, params);
                                e.target.selectedIndex = -1;
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option value="edit" disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)}>Edit</option>
                            <option value="delete" disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)}>Delete</option>
                        </select>
                    </div>
                )
            }
        },
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        // Check permission before performing any action
        if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
            toast.error(`You don't have ${action} permission`);
            e.target.selectedIndex = -1;
            return;
        }

        switch (action) {
            case "edit":
                setEditData(rowData);
                createVendorRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                confirm({
                    type: 'delete',
                    title: 'Delete Vendor',
                    message: 'Are you sure you want to delete this vendor?',
                    onConfirm: () => {
                        const payload = { VendorID: rowData.vendorID };
                        vendorApi.deleteVendor(payload, (resp: any, msg: any) => {
                            toast.success(msg);
                            getVendors();
                        }, (error: any) => {
                            console.log('error =>', error);
                            toast.error(error);
                        });
                    }
                });

                break;

            default:
                console.log("Unknown action: ", action);
        }
        e.target.selectedIndex = -1;
    };


    const getVendors = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        vendorApi.GetVendorList(
            payload,
            (resp: any) => {
                setrowData(resp.vendorList ? resp.vendorList : []);
                setTotalRecords(resp.totalRecord);
            },
            (error: any) => {
                toast.error(error);
            }
        );
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };
    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };

    const onBulkExportPdf = () => {
        // Check export permission
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have permission to export vendor data");
            return;
        }

        const selectedData = getSelectedRows();
        const payload: any = {};
        if (selectedData.length > 0) {
            const vendorIDs = selectedData.map((asset: any) => asset.vendorID).join(',');
            payload.vendorIDs = vendorIDs;
        }
        vendorApi.Exportpdf(
            payload,
            (resp: any) => {
                downloadPDF(resp, 'VendorPdf')
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const onBulkExportCsv = async () => {
        // Check export permission
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have permission to export vendor data");
            return;
        }

        const selectedData = getSelectedRows();
        const payload: any = {};
        if (selectedData.length > 0) {
            const vendorIDs = selectedData.map((asset: any) => asset.vendorID).join(',');
            payload.vendorIDs = vendorIDs;
        }
        vendorApi.Exportcsv(
            payload,
            (resp: any) => { downloadExcel(resp, 'VendorXls') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    // Call getVendors only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            getVendors();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (filtersInitialized) {
            getVendors();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
            locationFilter: false,
        });
    }, [currentPage, searchParam, filters]);

    return (
        <Layout>
            <Header title='Vendors List'>
                <Header.Right>
                    <Drawer isAfterOpenRender={true} _ref={createVendorRef} onClose={() => {
                        setEditData(null);
                    }}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, editData ? "Edit" : "Add", loggedinuser)}>New Vendor</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Vendor' : 'New Vendor'} className='!w-[50rem]'>
                            {(editData ? getPermissionInfo(location.pathname, "Edit", loggedinuser) : getPermissionInfo(location.pathname, "Add", loggedinuser)) ? (
                                <CreateVendor
                                    editID={editData?.vendorID}
                                    onCreate={() => {
                                        setEditData(null);
                                        getVendors();
                                        createVendorRef.current?.close();
                                    }}
                                    onCancel={() => {
                                        setEditData(null);
                                        createVendorRef.current?.close();
                                    }}
                                />
                            ) : (
                                <div className="p-4 text-center text-gray-500">
                                    You don't have permission to {editData ? "edit" : "add"} vendor.
                                </div>
                            )}
                        </Drawer.Content>
                    </Drawer>


                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Receive Stock'>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportPdf}>Export pdf</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>

            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <Search onSearch={setSearchParam} placeholder='Search by Vendor name' />
            </div>

            <div className='bg-[#FAFAFA]'>
                <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>
                        Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} />
                    </Button>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                        setFilters({});
                        localStorage.removeItem('vendorFilters');
                        setFiltersApplied({ generalFilter: false, locationFilter: false });
                        setCurrentPage(1);
                    }}>
                        Clear Filters
                    </p>
                </div>

                <div className="ag-theme-alpine mx-4 h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any}
                        rowData={rowData || []}
                        pagination={false}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default Vendor;